import React, { useContext, useState} from "react"
import { Outlet, Link,useLocation } from "react-router-dom"
import "./adminDash.css"
import AdminContext from "./AdminDashContext";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
export default function AdminDashboard() {
    // console.log("location",location)
  const styles=`
  @media(min-width:901px) and (max-width:1200px){
  .landing-page{
     font-size: 1.125rem ;
      line-height: 1.75rem ;
  }
  }
  @media(min-width:601px) and (max-width:900px){
  .landing-page{
      font-size: 1rem;
        line-height: 1.5rem;
  }
  }
  
  @media(min-width:401px) and (max-width:600px){
  .landing-page{
    font-size: 0.875rem ;
        line-height: 1.25rem;
  }
  }
  
  @media(min-width:0px) and (max-width:400px){
  .landing-page{
         font-size: 0.75rem ;
        line-height: 1rem;
  }
  }
`
const styleSheet=document.createElement("style")
styleSheet.type="text/css";
styleSheet.innerText=styles
document.head.appendChild(styleSheet)
 const {adminData}=useContext(AdminContext)
 const [dropdownVisible,setDropdownVisible]=useState(false)
  return (
    <div className="admindash bg-gray-100  flex flex-col  max-w-full min-w-fit max-h-full min-h-fit landing-page mt-20" >      
      <div
        className="relative w-28"
        onMouseEnter={() => setDropdownVisible(true)}
        onMouseLeave={() => setDropdownVisible(false)}
      >
        <Link to="account" className="hover:text-blue-500 flex flex-col">
          {adminData?.profile ? (
            <img
              src={adminData?.profile}
              alt={adminData?.username}
              className="h-16 w-16 rounded-full"
            />
          ) : (
            <FontAwesomeIcon icon={faUser} className=" h-12 w-12 rounded-full mx-2" />
          )}
          <p>Account</p>
        </Link>
        {dropdownVisible && (
          <div className=" top-20 left-0 bg-white shadow-lg rounded-md p-4 w-40">
            <Link
              to={`/adminDash/account/change`}
              className="block text-gray-700 hover:text-blue-500 mb-2"
            >
              <FontAwesomeIcon icon={faTachometerAlt} />Account
            </Link>
            <Link
              to={`/adminDash/account/logout`}
              className="block text-gray-700 hover:text-blue-500"
            >
              <FontAwesomeIcon icon={faSignOut} /> Logout
            </Link>
          </div>
        )}
      </div>
      <>
        <div className="flex flex-row space-x-2 mt-4">
          <Link to="hotels" className="hover:text-blue-500 ">Hotels</Link>
          <Link to="banks" className="hover:text-blue-500 ">Banks</Link>
          <Link to="transporters" className="hover:text-blue-500 ">Transporters</Link>
          <Link to="communicate">Communicate</Link>
        </div>
        <Outlet />
      </>

    </div>
  )
}



